<template>
  <div class="organisation-amount-total">
    <b-overlay :show="amountState.loading" rounded="sm" spinner-small>
      <slot />

      <div class="d-flex justify-content-between font-weight-bold">
        <span>{{ label || $t("total") }}</span>
        <span class="text-nowrap ml-2">{{ totalLabel }}</span>
      </div>
    </b-overlay>

    <div v-if="amountState.error" class="text-danger small mt-1">
      {{ $t("amount_could_not_be_loaded") }}
      <b-link class="ml-1" @click.stop.prevent="$emit('retry')">
        {{ $t("retry") }}
      </b-link>
    </div>
  </div>
</template>

<script>
import { planMixin } from "@/shared";

// FOYS-27334: the calculated amount on the payment step (DirectPayment /
// PayNowOrLater forms): the slot (per-plan lines) and the total, with a
// loader over the amounts while loading and a retry when it failed.
export default {
  name: "OrganisationAmountTotal",
  mixins: [planMixin],
  props: {
    // { loading: boolean, error: boolean, result: object|null }
    amountState: {
      type: Object,
      required: true,
    },
    currencyCode: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
  },
  computed: {
    totalLabel() {
      if (!this.amountState.result) {
        return "-";
      }

      return this.formatOrganisationPlanPrice(
        this.amountState.result.totalAmount || 0,
        this.amountState.result.currencyCode || this.currencyCode
      );
    },
  },
};
</script>
